import ApiHandler from './ApiHandler';

export default class ParameterApi {
    static async GenericGet(baseurl:string, url:string) {
        var response = await ApiHandler(baseurl).get(url);
        return response.data;
    }

    // static async UpdateList(parameterPutList: string) {
    //     var response = await ApiHandler(baseURL).put('parameter/UpdateList/'+parameterPutList);
    //     return response.data;
    // }
}
